export enum DashboardMutationTypes {
  SET_TOP5_COMPUTERS = "SET_TOP5_COMPUTERS",
  SET_TOP5_COMPUTERS_LOADING = "SET_TOP5_COMPUTERS_LOADING",
  SET_TOP5_COMPUTERS_ERROR = "SET_TOP5_COMPUTERS_ERROR",
  SET_TOP5_GROUPS = "SET_TOP5_GROUPS",
  SET_TOP5_GROUPS_LOADING = "SET_TOP5_GROUPS_LOADING",
  SET_EVENT_TRENDS = "SET_EVENT_TRENDS",
  SET_TOP_COMPUTERS = "SET_TOP_COMPUTERS",
  SET_BLOCKS_OVERTIME = "SET_BLOCKS_OVERTIME",
  SET_ALERT_SUMMARY = "SET_ALERT_SUMMARY",
  SET_COMPANY_OVERVIEW = "SET_COMPANY_OVERVIEW",
  SET_COMPANY_OVERVIEW_LOADING = "SET_COMPANY_OVERVIEW_LOADING",
  SET_ALERT_SUMMARY_LOADING = "SET_ALERT_SUMMARY_LOADING",
  SET_KNOWN_THREADS = "SET_KNOWN_THREADS",
  SET_KNOWN_THREADS_LOADING = "SET_KNOWN_THREADS_LOADING",
  SET_NUMBER_OF_BLOCKS_BY_TIME = "SET_NUMBER_OF_BLOCKS_BY_TIME",
}
